import React, { useState } from "react";
import { Box, Flex, Text } from "@chakra-ui/react";
import { useSelector } from "react-redux";

import TEMSeminarFr from "./TEMSeminarFr";
import TTESeminarFr from "./TTESeminarFr";

function TechnicalFr() {
  const isMobile = useSelector((state) => state.windowSize.isMobile);
  const [active, setActive] = useState("TEM"); // default left

  const contentAlign = isMobile ? "center" : "left";

  return (
    <Box
      // 0 margin on mobile, 15% on desktop
      mx={isMobile ? 0 : "10%"}
      py={8}
    >
      {/* -------- Segmented Toggle -------- */}
      <Flex
        w="100%"
        mb={8}
        border="1px solid"
        borderColor="gray.300"
        borderRadius="full"
        overflow="hidden"
      >
        <Flex
          flex="1"
          justify="center"
          align="center"
          textAlign="center"
          py={4}
          px={3}
          cursor="pointer"
          fontWeight="600"
          bg={active === "TEM" ? "gray.200" : "white"}
          transition="0.2s"
          onClick={() => setActive("TEM")}
        >
          SÉRIE DE SÉMINAIRES DE MENTORAT TECHNIQUE-ÉTHIQUE
        </Flex>

        <Flex
          flex="1"
          justify="center"
          align="center"
          textAlign="center"
          py={4}
          px={3}
          cursor="pointer"
          fontWeight="600"
          bg={active === "TTE" ? "gray.200" : "white"}
          transition="0.2s"
          onClick={() => setActive("TTE")}
        >
          ENTREPRENEURIAT EN TRANSFERT DE TECHNOLOGIE
        </Flex>
      </Flex>

      {/* -------- Content -------- */}
      {active === "TEM" ? (
        <>
          <Text
            fontSize="2xl"
            fontWeight="bold"
            textAlign="center"
            mb={4}
            textShadow="1px 1px gray"
          >
            SÉRIE DE SÉMINAIRES DE MENTORAT TECHNIQUE-ÉTHIQUE
          </Text>

          <Text fontSize="lg" textAlign={contentAlign} mb={6}>
            <b>La Série de Séminaires de Mentorat Technique-Éthique</b>, abrégée sous
            le nom de TEM, est un élément essentiel du programme TRAVERSAL. Cette
            série offre aux stagiaires des informations précieuses sur les dernières
            avancées techniques dans le domaine des véhicules autonomes (VA) et des
            véhicules aériens sans équipage (UAV). De plus, TEM aborde les dimensions
            légales et éthiques associées aux services basés sur les VA et les UAV.
            Elle comprend un minimum de huit séminaires par an, garantissant que les
            stagiaires acquièrent des connaissances complètes et des orientations à
            la fois techniques et éthiques dans leur domaine. Grâce à TEM, les
            stagiaires acquièrent une compréhension globale du paysage complexe et en
            évolution des technologies des VA et des UAV.
          </Text>

          <TEMSeminarFr />
        </>
      ) : (
        <>
          <Text
            fontSize="2xl"
            fontWeight="bold"
            textAlign="center"
            mb={4}
            textShadow="1px 1px gray"
          >
            ENTREPRENEURIAT EN TRANSFERT DE TECHNOLOGIE
          </Text>

          <Text fontSize="lg" textAlign={contentAlign} mb={6}>
            L&apos;aspect de l&apos;<b>Entrepreneuriat en Transfert de Technologie</b>{" "}
            du programme TRAVERSAL se concentre sur l&apos;équipement des stagiaires
            avec les connaissances et les compétences nécessaires pour la réussite de
            la préparation technologique et de la commercialisation. Ce segment
            propose des stratégies pour transformer les résultats de la recherche du
            programme en produits ou services commerciaux viables. Les stagiaires
            bénéficient du soutien en séminaire grâce aux bureaux de transfert de
            technologie et profitent de l&apos;expertise d&apos;anciens diplômés des
            accélérateurs de start-up. Pour garantir une formation complète, les
            stagiaires doivent assister à un minimum de quatre séminaires dans chaque
            filière par an. Cette emphase sur le transfert de technologie et
            l&apos;entrepreneuriat permet aux stagiaires de naviguer efficacement dans
            le parcours de la recherche aux applications réelles, favorisant ainsi
            l&apos;innovation et l&apos;impact économique.
          </Text>

          <TTESeminarFr />
        </>
      )}
    </Box>
  );
}

export default TechnicalFr;
